import { useQuery } from 'react-query';

import { categoriesToOptionsConverter } from '../../../utils/categoriesToOptionsConverter';

import { getDisconnectReasons } from 'RestAPIs/dutyHourTypes';

import { Option } from 'components/shared/ControlledFields/ControlledSelect';
import i18n from 'config/i18n';
import { getLocale } from 'utils/date';

const t = i18n.getFixedT(getLocale(), 'common');

export const useGetDisconnectReasonOptions = () =>
  useQuery<Option[]>({
    queryKey: ['disconnect_reasons', 'options'],
    queryFn: async () =>
      await getDisconnectReasons().then(
        categoriesToOptionsConverter({
          getValue: (value) => value.id,
          getLabel: (value) => value.name ?? `(${t('code')}) ${value.code}`
        })
      ),
    staleTime: Infinity
  });
